import statisticsCSS from "src/app/modules/admin/components/statistics/Statistics.module.css";

const StatisticsList = ({
  inputData,
  shouldNavigateToAdminProjects,
  navigateToAdminProjects,
  countLabel,
}: {
  inputData: Array<any>;
  shouldNavigateToAdminProjects: boolean;
  navigateToAdminProjects: (id: number, index: number) => void;
  countLabel: string;
}) => {
  return (
    <div className={statisticsCSS.listWrap}>
      <table className={statisticsCSS.listTable}>
        <tr className={statisticsCSS.queriesTotal}>
          <td>
            <span>Ukupno:</span>
          </td>
          <td>
            <span>-</span>&nbsp;
            {inputData.reduce((s, { projectsCount }) => s + projectsCount, 0)}&nbsp;
            <span>{countLabel}</span>
          </td>
        </tr>
        <tr className={statisticsCSS.totalBorder}>
          <td colSpan={3}></td>
        </tr>
        {inputData.map((element: any, index: number) => {
          return (
            <tr
              className={shouldNavigateToAdminProjects ? "u-cursor-pointer" : ""}
              onClick={() => {
                navigateToAdminProjects(inputData[index].id, index);
              }}
            >
              <td>{`#${index + 1}`}</td>
              <td>
                <span>{inputData[index].name}</span>&nbsp;&nbsp;
                <span>{inputData[index].address}</span>
              </td>
              <td>
                <span>-</span>&nbsp;
                {inputData[index].projectsCount}&nbsp;
                <span>{countLabel}</span>
              </td>
            </tr>
          );
        })}
      </table>
    </div>
  );
};

export default StatisticsList;
